// extracted by mini-css-extract-plugin
export default {"compactAll":"edit_compactAll__5aeiw","compactMobile":"edit_compactMobile__RhzNd"};